import { SCREENS } from "navigation/consts";
import TerminalSettings from "views/TerminalSettings";
import Settings from "views/Settings";
import { createStackNavigator } from "@react-navigation/stack";
import { useIntl } from "react-intl";
import VenueSettings from "views/VenueSettings";

import { SettingsNavigationParamList } from "./types";

const { Navigator, Screen } =
  createStackNavigator<SettingsNavigationParamList>();

const SettingsNavigation: React.FC = () => {
  const intl = useIntl();

  return (
    <Navigator screenOptions={{ headerTitleAlign: "center" }}>
      <Screen
        name={SCREENS.Settings}
        component={Settings}
        options={{
          title: intl.formatMessage({
            defaultMessage: "Settings",
          }),
        }}
      />
      <Screen
        name={SCREENS.TerminalSettings}
        component={TerminalSettings}
        options={{
          title: intl.formatMessage({
            defaultMessage: "Payment Terminal",
          }),
        }}
      />
      <Screen
        name={SCREENS.VenueSettings}
        component={VenueSettings}
        options={{
          title: intl.formatMessage({
            defaultMessage: "Venue",
          }),
        }}
      />
    </Navigator>
  );
};

export default SettingsNavigation;
